import currency, { Any, Options } from 'currency.js'
import { divide } from 'number-precision'
import { CodCurrencyType } from '@/store/serviceProviderSlice/types'

/**
 * format currency without symbol
 * @param value
 * @param options
 * @returns
 */
export const formatCurrency = (value: Any, options?: Options) => {
  const precision = value?.toString().includes('.') ? 2 : 0
  const precisionNum = typeof options?.precision === 'number' ? options?.precision : precision

  return currency(value, {
    symbol: '',
    ...options,
    precision: precisionNum,
  }).format()
}

/**
 * return the currency format
 */
export const unFormatCurrency = (value: Any) => {
  return currency(value).value
}

/**
 *
 * @param amount
 * @param precision 小数点
 * @returns
 */
export function translateCurrency(amount: number, precision?: number) {
  return formatCurrency(divide(amount || 0, 100), { precision })
}

// 指定COD币种的服务产品COD币种需要使用配置的特定币种
export const isCodCurrencyCodeSpecified = (codCurrencyType: CodCurrencyType) => codCurrencyType === 2
